<template>
    <auth-layout :snackbar="snackbar" @snackbar:close="snackbar = null">
        <div class="auth-login">
            <typo name="title-18-bold">
                {{ dico.connexion.title }}
            </typo>
            <sep name="M"></sep>
            <v-form class="form" ref="form" v-model="valid" @submit.prevent="submit">
                <text-field
                    required
                    v-model="values.loginOrEmail"
                    placeholder="Email / Login"
                    :rules="[required]"
                    @on-enter="submit"
                />
                <text-field
                    required
                    v-model="values.password"
                    placeholder="Mot de passe"
                    type="password"
                    :rules="[required]"
                    @on-enter="submit"
                />

                <widget-captcha @captcha:done="onCaptchaDone">
                    <div class="buttons">
                        <action
                            name="main"
                            :disabled="isSubmitting || !captcha.isValid"
                            @click="submit"
                        >
                            {{ dico.connexion.submit_cta }}
                        </action>

                        <v-progress-circular v-if="isSubmitting" indeterminate color="primary" />
                    </div>
                </widget-captcha>
                <div class="buttons">
                    <router-link to="/auth/first-connexion">
                        <action name="main">
                            {{ dico.connexion.first_connexion_cta }}
                        </action>
                    </router-link>
                </div>
            </v-form>

            <sep name="M"></sep>

            <div class="links">
                <router-link to="/auth/forgot-password">
                    <typo name="body-12-normal" class="link">
                        {{ dico.connexion.lost_password_cta }}
                    </typo>
                </router-link>
            </div>

            <sep name="M"></sep>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from "./AuthLayout.vue";
import TextField from "src/components/common/form/TextField.vue";
import WidgetCaptcha from "src/components/common/captcha/WidgetCaptcha.vue";
import { Services } from "src/services/Services";
import { initialAuthFormData } from "src/utils/auth-form";
import { EventBus } from "src/bus/eventBus";

export default {
    components: {
        AuthLayout,
        TextField,
        WidgetCaptcha,
    },
    data() {
        return {
            ...initialAuthFormData,
            values: {
                loginOrEmail: "",
                password: "",
                newEmail: "",
            },
            captcha: {
                token: null,
                isValid: false,
            },
        };
    },
    computed: {
        dico() {
            return this.$publicDico.login;
        },
        links() {
            return this.dico.connexion.links;
        },
    },
    watch: {
        values: {
            deep: true,
            handler() {
                if (this.snackbar) {
                    this.snackbar = null;
                }
            },
        },
    },
    methods: {
        onCaptchaDone(data) {
            this.captcha = {
                token: data.captchaToken,
                isValid: data.isCaptchaValid,
            };
        },
        async submit() {
            this.isSubmitting = this.$refs.form.validate() && this.captcha.isValid;
            if (!this.isSubmitting) {
                return;
            }
            const formValues = { ...this.values, captcha: this.captcha.token };
            try {
                await Services.api.auth.signIn(formValues);
                const redirectedUrl = this.$router.history.current.redirectedFrom
                    ? this.$router.history.current.redirectedFrom
                    : "";
                window.location.href = `/espace-client#${redirectedUrl}`;
            } catch (e) {
                const errorNameByCode = {
                    "auth/bad-credentials": "login_bad_credentials",
                    "auth/inactive-user": "inactive_user",
                };
                this.snackbar = {
                    text: this.dico.errors[errorNameByCode[e.payload.code] || "auth_general"],
                    color: "error",
                };
            } finally {
                this.isSubmitting = false;
                EventBus.$emit("captcha:reset");
            }
        },
    },
};
</script>

<style lang="sass" scoped>
.main-container
    max-width: 900px !important

.left
    padding: $padding-main
    display: flex
    flex-direction: column
    background: $color-pink

.right
    background: $color-background
    padding: $padding-main

.links
    display: flex
    flex-direction: column
    align-items: flex-start

.buttons
    display: flex
    align-items: center
    justify-content: space-between
    margin-top: $grid-gutter
    +r(480)
        margin-top: $grid-gutter/2

.form
    width: 400px

    +r(480)
        width: 310px
</style>
